/** Pointer clicks may auto-hide; keyboard navigation must keep tools available. */
export function chromeHasKeyboardFocus(root: HTMLElement): boolean {
  const active = document.activeElement;
  return document.hasFocus() && active instanceof HTMLElement && root.contains(active) &&
    !!active.closest('.sessbar, .toolbar, .session-edge-reveal') && active.matches(':focus-visible');
}
